import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import TextInput from '@components/textInput/TextInput'

import { FormikHelpers, useFormik } from 'formik'

import useI18n from '@i18n/useI18n'

interface Values {
  commentaire?: string
}

const Info = ({ form, onForm }: ControleFormProps) => {
  const i18n = useI18n()

  const init: Values = React.useMemo(() => ({ commentaire: form.commentaire }), [form.commentaire])

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  return (
    <MainContainer>
      <Description>{i18n.t('screens.controles.form.info.commentaire')}</Description>

      <TextInput
        value={values.commentaire}
        onChange={(val) => setFieldValue('commentaire', val)}
        placeholder={i18n.t('screens.controles.form.info.comment')}
        numberOfLines={8}
      />
    </MainContainer>
  )
}

export default Info

const MainContainer = styled(View)`
  margin: 0 20px;
  margin-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 25)}px;
  flex: 1;
`

const Description = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  color: ${(props) => props.theme.colors.secondaryText};
  margin-bottom: 20px;
  margin-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 25)}px;
`
